// extracted by mini-css-extract-plugin
module.exports = {"module":"Icon_module__Y8b6u","inFlow":"Icon_inFlow__kYuHi","notClickable":"Icon_notClickable__3PN-c"};